import React, {Component} from 'react'
import {connect} from 'react-redux'
import {validateProductionSearchField} from '../../../actions/pages/production-page'
import SingleLineSearchForm from '../../common/form/SingleLineSearchForm'
import InputField from '../../common/form/InputField'
import {clearProductionSearchFields} from '../../../actions/pages/production-page'

class ProductionSearch extends Component {

  componentWillUnmount() {
    this.props.clearProductionSearchFields();
  }

  render() {
    let fields = this.props.fields;
    
    return (
      <SingleLineSearchForm fields={fields} onSearch={this.props.onSearch}>
          <div className="col-5">
            <InputField field={fields[0]} validate={this.props.validateProductionSearchField} />
          </div>
      </SingleLineSearchForm>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  fields: state.productionSearch.fields
})
const mapDispatchToProps = dispatch => ({
  validateProductionSearchField(value, field) { dispatch(validateProductionSearchField(value, field)) },
  clearProductionSearchFields() { dispatch(clearProductionSearchFields()) }
})
export default connect(mapStateToProps, mapDispatchToProps)(ProductionSearch)